<template>
  <div class="order-list">
    <div class="empty-logo">
      <div class="rhombus-narrow"></div>
      <div class="rhombus-narrow left">
        <div class="border"></div>
      </div>
      <div class="rhombus-narrow right">
        <div class="border"></div>
      </div>
    </div>
    <p>没有符合条件的{{ title }}</p>
    <p>请稍后刷新查看或更改筛选条件。</p>
  </div>
</template>

<script>
export default {
  name: 'OrderList',
  props:['title'],
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.order-list {
  max-width: 320px;
  margin: 0 auto;
  text-align: center;

  p {
    margin: 16px 25px 0px;
    color: #9B9B9B;
    font-size: 16px;
  }
}

.empty-logo {
  width: 90px;
  margin: 0 auto;
  height: 165px;

  $width: 45px;
  $height: 26px;
  .rhombus-narrow {
    width: 0;
    height: 0;
    border: $width solid transparent;
    border-bottom: $height solid #333333;
    position: relative;
    top: -$width;
  }
  .rhombus-narrow:after {
    content: '';
    position: absolute;
    left: -$width;
    top: $height;
    width: 0;
    height: 0;
    border: $width solid transparent;
    border-top: $height solid #333333;
  }

  .left,
  .right {
    .border {
      position: absolute;
      width: 86px;
      height: 2px;
    }
  }

  .left {
    border-bottom-color: #888;
    &:after {
      border-top-color: #888;
    }
    transform:rotate(60deg);
    top: -55px;
    left: 5px;
    .border {
      top: 25px;
      left: -43px;
      background-color: #888;
    }
  }

  .right {
    border-bottom-color: #666666;
    &:after {
      border-top-color: #666666;
    }
    transform:rotate(-60deg);
    top: -126px;
    left: -5px;
    .border {
      top: 25px;
      left: -43px;
      background-color: #666666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/snatch/Empty.vue